<div class="cq" role="group" [attr.aria-label]="clarify().question">
  @for (question of clarify().questions; track question.id; let i = $index) {
    <fieldset class="cq-question" [attr.data-question]="i" [disabled]="disabled()">
      <legend class="cq-question-text">{{ question.question }}</legend>
      @if (question.multiple) {
        <span class="cq-hint">{{ '$ai.questionnaire.multiple' | translateAsync }}</span>
      }
      <div class="cq-options">
        @for (option of question.options; track option; let o = $index) {
          <button
            type="button"
            class="cq-option"
            [class.cq-option--picked]="isPicked(i, o)"
            [attr.aria-pressed]="isPicked(i, o)"
            [attr.title]="question.recommended.includes(o) ? ('$ai.questionnaire.recommended' | translateAsync) : null"
            [disabled]="disabled()"
            (click)="toggle(question, i, o)"
          >
            @if (isPicked(i, o)) {
              <mat-icon class="cq-check" aria-hidden="true">check</mat-icon>
            }
            <span class="cq-option-label">{{ option }}</span>
          </button>
        }
      </div>
      <input
        class="cq-other"
        type="text"
        maxlength="200"
        [value]="state()[i].other"
        [placeholder]="'$ai.questionnaire.other' | translateAsync"
        [attr.aria-label]="question.question"
        [disabled]="disabled()"
        (input)="type(i, $any($event.target).value)"
      />
    </fieldset>
  }
  <div class="cq-actions">
    <button mat-flat-button type="button" class="cq-submit" [class.cq-submit--alert]="purpose() === 'alert'" [disabled]="disabled() || !complete()" (click)="send()">
      <mat-icon>{{ purpose() === 'alert' ? 'notifications_active' : 'dashboard_customize' }}</mat-icon>
      {{ (purpose() === 'alert' ? '$ai.questionnaire.submit-alert' : '$ai.questionnaire.submit') | translateAsync }}
    </button>
  </div>
</div>
